module.exports = __webpack_public_path__ + "static/media/baxter-storey.1b68decd.jpg";